module.exports = __webpack_public_path__ + "img/CK.5389188d.svg";